import { CapoPlugin } from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];